export const OrganizationIcon = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon Placer">
        <path
          id="Vector"
          d="M14.0003 13.3335H15.3337V14.6668H0.666992V13.3335H2.00033V2.00016C2.00033 1.63198 2.29881 1.3335 2.66699 1.3335H13.3337C13.7019 1.3335 14.0003 1.63198 14.0003 2.00016V13.3335ZM12.667 13.3335V2.66683H3.33366V13.3335H12.667ZM5.33366 7.3335H7.33366V8.66683H5.33366V7.3335ZM5.33366 4.66683H7.33366V6.00016H5.33366V4.66683ZM5.33366 10.0002H7.33366V11.3335H5.33366V10.0002ZM8.66699 10.0002H10.667V11.3335H8.66699V10.0002ZM8.66699 7.3335H10.667V8.66683H8.66699V7.3335ZM8.66699 4.66683H10.667V6.00016H8.66699V4.66683Z"
          fill="#1D7AFC"
        />
      </g>
    </svg>
  );
};
